import "./ApiErrorComponent.scss";
import { Typography, Box } from "@mui/material";
import LockPersonOutlinedIcon from "@mui/icons-material/LockPersonOutlined";
import { useNavigate } from "react-router-dom";
import {
  NO_PERMISSION_TEXT,
  ACCESS_DENIED,
} from "../../utility/constants/locale";

interface ApiErrorProps {
  errorMessage?: string;
  colorCode?: string;
  errorCode?: number;
}

const ApiErrorComponent: React.FC<ApiErrorProps> = ({
  errorMessage,
  colorCode,
  errorCode,
}) => {
  const navigate = useNavigate();
  return (
    <>
      {!errorCode && (
        <Typography color={colorCode || "error"} sx={{ paddingTop: "10px" }}>
          {errorMessage ? errorMessage : "Error loading data"}
        </Typography>
      )}

      {errorCode === 403 && (
        <Box
          sx={{
            paddingTop: "150px",
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <LockPersonOutlinedIcon sx={{ fontSize: 100, color: "#a41e35" }} />
          </Box>
          <Typography
            sx={{
              textAlign: "center",
              fontSize: "22px",
              fontWeight: "600",
              wordSpacing: "1.3px",
            }}
          >
            {ACCESS_DENIED}
          </Typography>
          <Typography sx={{ paddingTop: "10px", textAlign: "center" }}>
            {NO_PERMISSION_TEXT}
          </Typography>
        </Box>
      )}

      {errorCode === 401 && navigate("/")}
    </>
  );
};

export default ApiErrorComponent;
